import axios from 'axios';
import { captureApiException } from '@lib/monitoring';

const axiosPublic = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosPublic.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    captureApiException(error, 'public');
    return Promise.reject(error);
  },
);

export default axiosPublic;
